var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "close-container navigation-wrap",
      class: { line: _vm.line },
      style: _vm.isBlue ? "background: #0054F0" : " background: #E40000",
    },
    [
      _c(
        "div",
        { staticClass: "left-container" },
        [
          _vm._t("left", function () {
            return [
              _vm.showIconBack
                ? _c("i", {
                    staticClass: "bluepay-icon-back cursor-pointer",
                    on: { click: _vm.clickLeft },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c("span", { staticClass: "head-title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._t("right"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }